/* eslint-disable import/prefer-default-export */
import { useCallback, useEffect, useReducer } from 'react';

import {
  DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS,
  daysIDsToApproveOrRejectReducer
} from '../reducer/daysIDsToApproveOrRejectReducer';

/**
 * @param {import('../../../adapters/weekly-report/get-weekly-report-adapter').TableData} tableData
 * @param {import('./useFilters').Filters} filters
 */
export const useDaysToApproveOrReject = (tableData, filters) => {
  /** @type {[Set<number>, React.Dispatch<{type, action?}>]} reducer */
  const [daysIDsToApproveOrReject, dispatch] = useReducer(
    daysIDsToApproveOrRejectReducer,
    new Set()
  );

  const handleDay = useCallback(
    /** @param {string} id @param {number} dailyReportID */
    (id, dailyReportID) =>
      dispatch({
        type: DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_DAY,
        payload: { id, dailyReportID }
      }),
    []
  );

  const handleLine = useCallback(
    /** @param {string} id */
    (id) =>
      dispatch({
        type: DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_LINE,
        payload: { id, tableData, filters }
      }),
    [tableData, filters]
  );

  const handleGroup = useCallback(
    /** @param {number} id */ (id) =>
      dispatch({
        type: DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_GROUP,
        payload: { id, tableData, filters }
      }),
    [tableData, filters]
  );

  // const handleCheckAll = useCallback(
  //   /** @param {import('../../../adapters/weekly-report/get-weekly-report-adapter').TableData} newData */
  //   (newData) =>
  //     dispatch({
  //       type: DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_CHECK_ALL,
  //       payload: { tableData, newData }
  //     }),
  //   [tableData]
  // );

  const getIDsToSend = useCallback(
    /** @returns {number[]} */
    () => [...daysIDsToApproveOrReject],
    [daysIDsToApproveOrReject]
  );

  const handleResetDaysIDsToApproveOrReject = useCallback(() => {
    dispatch({ type: DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.RESET_STATE });
  }, []);

  // Collect the saved data in session storage and set as initial State
  useEffect(() => {
    const savedIDs = sessionStorage.getItem('weeklyReportTableIDsToApprove');

    if (savedIDs) {
      const initialData = JSON.parse(savedIDs);

      dispatch({
        type: DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.SET_INITIAL_DATA,
        payload: { initialData }
      });
    }
  }, []);

  // Save in session storage the ids to approve when
  useEffect(() => {
    sessionStorage.setItem(
      'weeklyReportTableIDsToApprove',
      JSON.stringify([...daysIDsToApproveOrReject])
    );
  }, [daysIDsToApproveOrReject]);

  return {
    daysIDsToApproveOrReject,
    getIDsToSend,
    // handleCheckAll,
    handleDay,
    handleGroup,
    handleLine,
    handleResetDaysIDsToApproveOrReject
  };
};
